module.exports = {
    alphabetise: function (array) {
        array.sort(function(a, b){
            if(a < b) return -1;
            if(a > b) return 1;
            return 0;
        })
        return array;
    },
    sortDescending: function(array, val) {
        array.sort(function(a, b){
            if(a[val] < b[val]) return 1;
            if(a[val] > b[val]) return -1;
            return 0;
        })
        return array;
    },
    orderObject: function (object) {
        ordered = {};
        Object.keys(object).sort().forEach(function(key) {
            ordered[key] = object[key];
        });
        return ordered;
    },
    checkExists: function (id, library, field) {
        exists = false;
        for(l in library) {
            if(field === 'source' || field === 'target') {
                info = library[l][field].id
            } else if (field === 'none') {
                info = library[l]
            } else {
                info = library[l][field]
            }

            if(id === info) {
                exists = true;
            }
        }
        return exists;
    },
    formatDate: function (date) {
        if(date != '') {
            sections = date.split('/')
            if(sections.length > 1) {
                date = sections[2];
            } else {
                date = sections[0];
            }
        }
        return date;
    },
    scrollTo: function(id) {
        $('body, html').animate({
            scrollLeft: $("#"+id).offset().left - (window.innerWidth / 2)
        }, 2000);
    },
    makePercent: function(el) {
        total = 0;
        el.forEach(function(e) {
            total = total + e.value;
        })
        el.forEach(function(d) {
            d.pc = Math.floor((d.value / total ) * 100)
        });
    },
    checkList: function(val, library) {
        if(this.checkExists(val, library, 'title') == true) {
            ++library.filter(function(d) { return d.title == val;})[0].value
        } else {
            library.push({title:val, value: 1, pc:null});
        }
    },
    streetView: function(lat, lon) {
        var panorama = new google.maps.StreetViewPanorama(
            document.getElementById('street-view'),
            {
                position: {lat: 37.869260, lng: -122.254811},
                pov: {heading: 165, pitch: 0},
                zoom: 1
            }
        );
    },
	splitList: function(word) {
    	var newWords = word.split(",")
		result = ""
		newWords.forEach(function(d, i) {
			if(i===newWords.length -1) {
                result += d
			} else {
                result += d + " and "
            }
		})
		return result;
	},
	verticalCenter: function(obj, container) {
    	contHeight = container.height()
		objHeight = obj.height()
    	obj.css('position', 'relative').css('top', String(( contHeight - objHeight) / 2) + "px")
	}
}

/*    function makePercent(el) {
	total = 0;
	el.forEach(function(e) {
	    total = total + e.value;
	})
	el.forEach(function(d) {
	    d.pc = Math.floor((d.value / total ) * 100)
	});
    }

    function checkList(val, library) {
	if(utils.checkExists(val, library, 'title') == true) {
	    ++library.filter(function(d) { return d.title == val;})[0].value
	} else {
	    library.push({title:val, value: 1, pc:null});
	}
    }
*/
